import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=15630060&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=js&"
export * from "./storage.vue?vue&type=script&lang=js&"
import style0 from "./storage.vue?vue&type=style&index=0&id=15630060&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15630060",
  null
  
)

export default component.exports